module.exports = __webpack_public_path__ + "static/media/next.f94d943c.svg";